// extracted by mini-css-extract-plugin
export default {"imageWrapper":"oE-z","hovered":"pE-z","hoverImage":"qE-z","mainImage":"rE-z","imageNoBackground":"sE-z","fullSizeImage":"tE-z"};